<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="A5m"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Copyright Page">
<p class="copy" id="pAr">© 1991, 1993, 1995, 1997 by H. Jackson Brown, Jr.</p>
<div class="image1" id="A7"><img alt="" id="AtN" role="presentation" src="images/himg-2-1.jpg"/></div>
<p class="copy1" id="pAb">All rights reserved. Written permission must be secured from the publisher to use or reproduce any <br/> part of this book, except for brief quotations in critical reviews or articles.</p>
<p class="copy1" id="pA1">Published in Nashville, Tennessee, by Thomas Nelson. Thomas Nelson <br/> is a registered trademark of HarperCollins Christian Publishing, Inc.</p>
<p class="copy1" id="pAC">Thomas Nelson titles may be purchased in bulk for educational, business, fund-raising, or sales <br/> promotional use. For information, please e-mail SpecialMarkets@ThomasNelson.com.</p>
<p class="copy2" id="pAR">Design by Gary Gore | Typography by D&amp;T/Bailey Typesetting, Inc., Nashville, Tennessee<br/> <br/></p>
<p class="isbn1"><span class="digits">978-1-4185-7129-0</span> (eBook)</p>
<p class="libraryofcongress1" id="pAdm"><b>Library of Congress Cataloging-in-Publication Data</b></p>
<p class="libraryofcongress2" id="pAA">Brown, H. Jackson, 1940–</p>
<p class="libraryofcongress3" id="pAP1">[Life’s little instruction book]</p>
<p class="libraryofcongress3" id="pAMX">The complete life’s little instruction book / H. Jackson Brown, Jr.</p>
<p class="libraryofcongress4" id="pAg">p. cm.</p>
<p class="libraryofcongress3" id="pA27">Originally published in 3 vols. : Life’s little instruction book.</p>
<p class="libraryofcongress5" id="pAu">Nashville, Tenn. : Rutledge Hill Press, c1991–c1995.</p>
<p class="isbn" id="pA8">ISBN 978-1-55853-490-2</p>
<p class="libraryofcongress3" id="pAj">1. Happiness—Quotations, maxims, etc. 2. Conduct of life—</p>
<p class="libraryofcongress5" id="pAT">Quotations, maxims, etc. I. Title.</p>
<p class="libraryofcongress5" id="pAL">[BJ1481.B87 1997]</p>
<p class="libraryofcongress5" id="pALo">170’.44—dc21     97-5575</p>
<p class="libraryofcongress6" id="pAz"><span class="spell">CIP</span></p>
<p class="other" id="pAE">19 20 21 22 23 <span class="spell">SHR</span> 29 28 27 26 25</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?32bece26